<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="this.$l('purchase_package_detail_search')||'包装编号/包装名称/包装规格搜索'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="disabled"
              v-if="allow('A')"
              @click="
                $emit('openEditFormDialog', {
                  type: 'add',
                })
              "
            >
              <b-icon-plus></b-icon-plus>
              {{ $l("INDEX.btn_add") || "新增" }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-danger"
              @click="$emit('batchDel')"
              :disabled="disabled"
              v-if="allow('D')"
            >
              <i class="el-icon-delete"></i
              >{{ $l("INDEX.btn_delete") || "删除" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="750px"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="form"  size="small">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_package_no')||'包装编号'">
                <el-input v-model.trim="form.packageNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_package_name')||'包装名称'">
                <el-input
                  v-model.trim="form.packageName"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_package_specification')||'包装规格'">
                <el-input
                  v-model.trim="form.packageDesc"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l("INDEX.btn_cancel_query") || "取消查询"
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l("INDEX.btn_reset_filter") || "重置条件"
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l("INDEX.btn_data_retrieval") || "数据检索"
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  keyword: "",
}

export default {
  props: {
    purchasePackageCode: String,
    purchasePackageDetailCode: String,
    disabled: Boolean,
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query() {
      this.$emit("query", this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
